<template>
    <div class="custom-form-group" :class="[formGroupClass, {'is-invalid': getError(name)}]">
        <div :class="{'form-floating': floatLabel}">
            <label class="form-label" :for="uniqid" v-if="!floatLabel && label">{{ label }}<span v-if="required">*</span></label>
            <select class="form-select" :class="{'is-invalid': getError(name)}" :id="uniqid" :name="name" v-model="localValue">
                <option :key="i" :value="option.value" v-for="(option, i) in options">{{ option.label }}</option>
            </select>
            <label :for="uniqid" v-if="floatLabel && label">{{ label }}<span v-if="required">*</span></label>
            <div class="invalid-feedback" :id="uniqid+'-feedback'">
                {{ errorMessage }}
            </div>
        </div>
    </div>
</template>

<script>

import uniqid from 'uniqid'

export default {

    props: {
        value: {
            required: true
        },
        name: {
            required: true
        },
        label: {
            default: false
        },
        formGroupClass: {
            default: null
        },
        options: {
            required: true
        },
        customErrorMessage: {
            default: null
        },
        floatLabel: {
            default: false
        },
        required: {
            default: false
        }
    },

    inject: [
        'getError',
        'clearError'
    ],

    data () {
        return {
            localValue: this.value,
            uniqid: uniqid()
        }
    },

    watch: {
        localValue: {
            deep: true,
            handler () {
                this.updateValue()
            }
        }
    },

    computed: {
        errorMessage () {
            if (this.getError(this.name) && Array.isArray(this.getError(this.name))) {
                if (this.customErrorMessage) {
                    return this.customErrorMessage
                } else {
                    return this.getError(this.name)[0]
                }
            }
            return ''
        }
    },

    methods: {
        updateValue () {
            this.$emit('input', this.localValue)
            this.clearError(this.name)
        }
    }

}
</script>
